export const APP_NAME_HO: string = 'MortgageOrientation';

export const APP_NAME_HA_IN_IFRAME: string = 'MortgageRequest';
export const IFRAME_NAME_HA: string = 'AbnAmroWidgetHost';

export const APP_NAME_SHB_IN_IFRAME: string = 'SnelleHypotheekBerekening';
export const APP_NAME_KETO_IN_IFRAME: string = 'KennisEnErvaringstoetsOpen';

export const APP_NAME_OWO_IN_IFRAME: string = 'OverwaardeOrientation';

export const APP_NAME_IRT_IN_IFRAME: string = 'interest-rates';

export enum Events {
  Acknowledgement = 'acknowledgement',
  ExtendSession = 'extendSession',
  NavigateTo = 'navigateTo',
  OpenChatWindow = 'openChatWindow',
  Ready = 'ready',
  Unauthenticated = 'unauthenticated',
  ShowToastMessage = 'showToastMessage',
  SetPageTitle = 'setPageTitle'
}
